// make a modal overlay component
import React from "react";
import { Link } from "react-router-dom";

export default function TrialModal({ open, trialEnd, trialStatus, closeModal }) {
	const trialEndDate = new Date(trialEnd);
	const trialEndDateString = trialEndDate.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
	const title = trialStatus === "active" ? "Welcome to your Preflop Mastery trial" : "Your Preflop Mastery trial has expired";
	const content =
		trialStatus === "active"
			? `You have until ${trialEndDateString} to use all NLHE and PLO features for free. After that, subscribe to continue your training.`
			: "Your trial has expired. Subscribe to continue your training.";
	return (
		<div className={`modal-overlay ${open ? "show" : "hide"}`} onClick={closeModal}>
			<div className="modal-content">
				<h1>{title}</h1>
				<p>{content}</p>
				<div className="modal-content-buttons">
					<button>
						<Link to="/subscribe">Subscribe Now</Link>
					</button>
					<button onClick={closeModal}>Okay</button>
				</div>
			</div>
		</div>
	);
}
